import { adobeLinkTracking, adobePageViewTracking, getPageNameId, logAlsLead, logAlsImpression, assignPageNameAndFire } from "../../../../helpers/osTracking";
import Toast from '../toastComponent';

class NavigationWrapper {
    constructor(OS_MODAL, used, emitter) {
        this.used = used;
        this.emitter = emitter;
        this.paymentOptionButtonContainer = OS_MODAL.querySelector('.payment-details__options');
        this.headerContainer = OS_MODAL.querySelector('.payment-details__header-container');
        this.navButtonContainer = OS_MODAL.querySelector('.payment-details__nav');
        this.primaryCta = OS_MODAL.querySelector('.payment-details__primary-cta');
        this.secondaryCta = OS_MODAL.querySelector('.payment-details__secondary-cta');
        this.multiActionCTA = OS_MODAL.querySelector('.payment-details__multiaction-container');
        this.milesContainer = OS_MODAL.querySelector('.miles--container');
        this.termLeaseContainer = OS_MODAL.querySelector('.term-lease--container');
        this.termFinanceContainer = OS_MODAL.querySelector('.term-finance--container');
        this.downPaymentContainer = OS_MODAL.querySelector('.input-container__down-payment');
        this.radioButtons = OS_MODAL.querySelectorAll('.radio-nav');
        this.navBodyContainer = OS_MODAL.querySelector('.payment-details__body-container');
        this.creditInput = OS_MODAL.querySelector('.input-container.credit-input');
        this.creditRows = OS_MODAL.querySelector('.cr-rows');
        this.updatesText = OS_MODAL.querySelector('.input-container__updates-text');
        this.updatesTextBot = OS_MODAL.querySelector('.updates-text-bot');
        this.dealsTab = OS_MODAL.querySelector('.payment-details__nav-containers.deals');
        this.closeButton = OS_MODAL.querySelector('[name="close"]');
        this.infoContainer = OS_MODAL.querySelector('.payment-details__payment-container .info');
        this.monthlyPayment = OS_MODAL.querySelector('.monthly-payment');
        this.itemizedContainer = OS_MODAL.querySelector('.payment-details__itemized-container');
        this.loadingHeader = OS_MODAL.querySelector('.payment-details__loading-container');

        this._minimizedHeader = false;

        this.paymentDetails = OS_MODAL.querySelector('.payment-details');
        this.multiActionFormsContainer = OS_MODAL.querySelector('.multi-action-forms');
        this.phoneCallForm = this.multiActionFormsContainer.querySelector('.phone-call-form__container');
        this.questionForm = this.multiActionFormsContainer.querySelector('.question-form__container');
        this.testDriveForm = this.multiActionFormsContainer.querySelector('.test-drive-form__container');
        this.phoneCallBackButton = this.phoneCallForm.querySelector('.phone-call-form__back');
        this.questionBackButton = this.questionForm.querySelector('.question-form__back');
        this.testDriveBackButton = this.testDriveForm.querySelector('.test-drive-form__back');
    }

    init(vehicleState) {
        this.vehicleState = vehicleState;
        this.selected = this.vehicleState.payments.selected;

        this._selectCurrentPaymentOption();

        this.paymentOptionButtonContainer.addEventListener("change", e => {
            this._updatePaymentView(e.target.value);
            this.emitter.emit('user-changed-value', e, 'payment-option');
        });

        this.navButtonContainer.addEventListener("change", e => {
            this._updateNavView(e.target.value);
            this._updatePrimaryCta(e.target.value);
        });

        this.primaryCta.addEventListener("click", e => {
            this._goToNextPage(e.target.innerText);
        });

        this.secondaryCta.addEventListener("click", e => {
            this._goToNextPage(e.target.innerText);
        });

        this.navBodyContainer.addEventListener("scroll", (event) => {
            const offset = this._minimizedHeader ? 0 : 109;
            this._handleScroll(event.target, offset, this.navBodyContainer.offsetHeight);
        });
        this.multiActionCTA.addEventListener("click", () => this._fireFlyoutTracking());
        this.multiActionCTA.addEventListener("change", event => this._handleMultiaction(event));

        this.phoneCallBackButton.addEventListener("click", event => this._handleFormBack(event));
        this.questionBackButton.addEventListener("click", event => this._handleFormBack(event));
        this.testDriveBackButton.addEventListener("click", event => this._handleFormBack(event));
    }

    _fireFlyoutTracking() {
        adobeLinkTracking('onlineShopper/deals','submit-deals');
    }

    _handleScroll(target, offset, containerOffsetHeight) {
        if (target.scrollTop > 0 && target.scrollHeight > containerOffsetHeight + offset) {
            this._minimizeHeader();
            this._minimizedHeader = true;
        } else {
            this._showFullHeader();
            this._minimizedHeader = false;
        }
    }

    _handleMultiaction(event) {
        const value = event.target.value;

        switch (value) {
            case "phonecall":
                Toast.show('check-circle', 'Success!', 'The seller will be in touch to confirm your deal.');
                this.paymentDetails.classList.add("hidden");
                this.multiActionFormsContainer.classList.remove("hidden");
                this.phoneCallForm.classList.remove("hidden");
                adobePageViewTracking('onlineShopper/deals','flyout-phone','onlineShopper/connectPhone');
                logAlsImpression(0, getPageNameId('phoneCall', this.vehicleState.payments.selected));
                break;
            case "question":
                Toast.show('check-circle', 'Success!', 'The seller will be in touch to confirm your deal.');
                this.paymentDetails.classList.add("hidden");
                this.multiActionFormsContainer.classList.remove("hidden");
                this.questionForm.classList.remove("hidden");
                adobePageViewTracking('onlineShopper/deals','flyout-question','onlineShopper/connectQuestion');
                logAlsImpression(0, getPageNameId('askQuestion', this.vehicleState.payments.selected));
                break;
            case "testdrive":
                Toast.show('check-circle', 'Success!', 'The seller will be in touch to confirm your deal.');
                this.paymentDetails.classList.add("hidden");
                this.multiActionFormsContainer.classList.remove("hidden");
                this.testDriveForm.classList.remove("hidden");
                adobePageViewTracking('onlineShopper/deals','flyout-testdrive','onlineShopper/connectTestDrive');
                logAlsImpression(0, getPageNameId('testDrive', this.vehicleState.payments.selected));
                break;
            case "finished":
                Toast.show('check-circle', 'Success!', 'The seller will be in touch to confirm your deal.');
                adobePageViewTracking('onlineShopper/deals', 'flyout-finish', 'onlineShopper/imFinished/success');
                /* istanbul ignore next */
                if (this.closeButton) {
                    this.closeButton.click();
                }
                break;
        }
        // Tracking with ALS impression since we do not have a lead event id for the ALS lead tracking
        logAlsImpression(0, getPageNameId('vdp'));
    }

    _handleFormBack(event) {
        const value = (event.target).getAttribute("value");
        switch (value) {
            case "question":
                this.questionForm.classList.add("hidden");
                break;
            case "phone-call":
                this.phoneCallForm.classList.add("hidden");
                break;
            case "test-drive":
                this.testDriveForm.classList.add("hidden");
                break;
            default:
                this.questionForm.classList.add("hidden");
                this.phoneCallForm.classList.add("hidden");
                this.testDriveForm.classList.add("hidden");
        }

        this.multiActionCTA.querySelector('select').innerHTML = `
            <option class="multiaction__option" value="default">Continue</option>
            <option class="multiaction__option" data-linkname="flyout-finish" value="finished">I'm
                finished</option>
            <option class="multiaction__option" data-linkname="flyout-testdrive" value="testdrive">Schedule
                test drive</option>
            <option class="multiaction__option" data-linkname="flyout-phone" value="phonecall">Request phone
                call</option>
            <option class="multiaction__option" data-linkname="flyout-question" value="question">Ask a
                question</option>
            `;

        this.paymentDetails.classList.remove("hidden");
        this.multiActionFormsContainer.classList.add("hidden");
    }

    _selectCurrentPaymentOption() {
        const selectedInput = this.paymentOptionButtonContainer.querySelector(`input.${this.selected}-input`);
        selectedInput.checked = true;
        this._updatePaymentView(this.selected);
    }

    _goToNextPage(nextPage) {
        nextPage = nextPage.split(' ').join('');
        if (nextPage === 'Continuetoaddrebates') {
            this.radioButtons[1].click();
        } else if (nextPage === 'Continuetoaddtrade-in') {
            this.radioButtons[2].click();
        } else if (nextPage === 'Continue' || nextPage === 'Skipthisstep') {
            this.radioButtons[3].click();
        }

        this.navBodyContainer.scrollTop = 0;
    }

    _updatePrimaryCta(option) {
        if (option === "details") {
            if (this.used) {
                this.primaryCta.innerText = 'Continue to add trade-in';
            } else {
                this.primaryCta.innerText = 'Continue to add rebates';
            }
            this.primaryCta.setAttribute('data-linkname', 'add-rebates-online-shopper');
            this.primaryCta.classList.remove("hidden");
            this.secondaryCta.classList.add("hidden");
            this.multiActionCTA.classList.add("hidden");
            assignPageNameAndFire('onlineShopper/paymentDetails');
        } else if (option === "rebates") {
            this.primaryCta.innerText = 'Continue to add trade-in';
            this.primaryCta.setAttribute('data-linkname', 'add-trade-online-shopper');
            this.primaryCta.classList.remove("hidden");
            this.secondaryCta.classList.add("hidden");
            this.multiActionCTA.classList.add("hidden");
            assignPageNameAndFire('onlineShopper/rebates');
        } else if (option === "trade-in") {
            this.primaryCta.innerText = 'Continue';
            this.emitter.emit('primary-cta-clicked');
            this.primaryCta.setAttribute('data-linkname', 'add-deals-online-shopper');
            this.multiActionCTA.classList.add("hidden");
        } else {
            this.primaryCta.classList.add("hidden");
            this.multiActionCTA.classList.remove("hidden");
            this.secondaryCta.classList.add("hidden");
            assignPageNameAndFire('onlineShopper/deals');
        }

        this.navBodyContainer.scrollTop = 0;
    }

    _updateNavView(option) {
        const navBodies = this.navBodyContainer.children;

        for (let element of navBodies) {
            if (option === element.getAttribute("value")) {
                element.classList.remove("hidden");
            } else {
                element.classList.add("hidden");
            }
        }
    }

    _updatePaymentView(option) {
        if (option === "loan") {
            this.termLeaseContainer.classList.add("hidden");
            this.milesContainer.classList.add("hidden");
            this.termFinanceContainer.classList.remove("hidden");
            this.downPaymentContainer.classList.remove("hidden");
            this.creditInput.classList.remove("hidden");
            this.creditRows.classList.remove("hidden");
            this.updatesText.classList.add("hidden");
            this.updatesTextBot.classList.remove("hidden");
            this.dealsTab.classList.remove("hidden");
        } else if (option === "lease") {
            this.termFinanceContainer.classList.add("hidden");
            this.termLeaseContainer.classList.remove("hidden");
            this.milesContainer.classList.remove("hidden");
            this.downPaymentContainer.classList.remove("hidden");
            this.creditInput.classList.remove("hidden");
            this.creditRows.classList.remove("hidden");
            this.updatesText.classList.add("hidden");
            this.updatesTextBot.classList.remove("hidden");
            this.dealsTab.classList.remove("hidden");
        } else {
            this.termFinanceContainer.classList.add("hidden");
            this.termLeaseContainer.classList.add("hidden");
            this.milesContainer.classList.add("hidden");
            this.downPaymentContainer.classList.add("hidden");
            this.creditInput.classList.add("hidden");
            this.creditRows.classList.add("hidden");
            this.dealsTab.classList.remove("hidden");
            this.updatesText.classList.remove("hidden");
            this.updatesTextBot.classList.add("hidden");
        }

        this.navBodyContainer.scrollTop = 0;
    }

    _minimizeHeader() {
        this.paymentOptionButtonContainer.classList.add('minimize');
        this.monthlyPayment.classList.add('minimize');
        this.infoContainer.classList.add('minimize');
        this.headerContainer.classList.add('minimize');
        this.navBodyContainer.classList.add('minimize');
        this.itemizedContainer.classList.add('minimize');
        this.loadingHeader.classList.add('minimize');
    }

    _showFullHeader() {
        this.monthlyPayment.classList.remove('minimize');
        this.paymentOptionButtonContainer.classList.remove('minimize');
        this.infoContainer.classList.remove('minimize');
        this.headerContainer.classList.remove('minimize');
        this.navBodyContainer.classList.remove('minimize');
        this.itemizedContainer.classList.remove('minimize');
        this.loadingHeader.classList.remove('minimize');
    }
}

export default NavigationWrapper;
